<div class="container" style="padding: 0px; margin: 0px;background-color: #ffffff;width: 100%;max-width: 1153px;height: auto;border-radius: 5px;">
  <div class="row">
    <!-- Form Section (Full Width on Mobile, Half on Desktop) -->
    <div class="col-lg-6 col-md-12">
      <h1 style="color: #14274e;margin-top: 40px;margin-left: 35px;">Facility Details</h1>
      <form [formGroup]="facilityDetailsFormGroup">
        <div class="form-group" style="margin-right: 30px;margin-left: 37px;width: 350px;margin-top: 28px;">
          <!-- Facility Name -->
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">FACILITY NAME</label>
          <input type="text" class="form-control" formControlName="facilityNameFormControl" placeholder="Facility Name"
                 style="width: 350px;height: 40px;"/>
        </div>

        <!-- Facility Type -->
        <div class="form-group" style="margin-top: 10px;margin-right: 30px;margin-left: 37px;width: 350px;">
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">FACILITY TYPE</label>
          <select class="form-control" formControlName="facilityTypeFormControl" (change)="selectValueChangeForFacilityType()"
                  style="width: 350px;height: 40px;">
            <option *ngFor="let facilityType of facilityTypes" [value]="facilityType.id">
              {{ facilityType.tenantCategory }}
            </option>
          </select>
        </div>

        <!-- Address Line 1 -->
        <div class="form-group" style="margin-top: 10px;margin-right: 30px;margin-left: 37px;width: 350px;">
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">ADDRESS LINE 1</label>
          <input type="text" class="form-control" formControlName="addressLine1FormControl" placeholder="Address Line 1"
                 style="width: 350px;height: 40px;"/>
        </div>

        <!-- Address Line 2 -->
        <div class="form-group" style="margin-top: 10px;margin-right: 30px;margin-left: 37px;width: 350px;">
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">ADDRESS LINE 2</label>
          <input type="text" class="form-control" formControlName="addressLine2FormControl" placeholder="Address Line 2"
                 style="width: 350px;height: 40px;"/>
        </div>

        <!-- City -->
        <div class="form-group" style="margin-top: 10px;margin-right: 30px;margin-left: 37px;width: 350px;">
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">CITY</label>
          <select class="form-control" formControlName="cityFormControl" (change)="selectValueChangeForCity()"
                  style="width: 350px;height: 40px;">
            <option *ngFor="let city of cities" [value]="city">{{ city }}</option>
          </select>
        </div>

        <!-- Pincode -->
        <div class="form-group" style="margin-top: 10px;margin-right: 30px;margin-left: 37px;width: 350px;">
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">PINCODE</label>
          <input type="text" class="form-control" formControlName="pincodeFormControl" placeholder="Pincode"
                 style="width: 350px;height: 40px;"/>
        </div>

        <!-- Phone Number 1 -->
        <div class="form-group" style="margin-top: 10px;margin-right: 30px;margin-left: 37px;width: 350px;">
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">PHONE NUMBER 1</label>
          <input type="text" class="form-control" formControlName="phoneNumber1FormControl" placeholder="Phone Number 1"
                 style="width: 350px;height: 40px;"/>
        </div>

        <!-- Phone Number 2 -->
        <div class="form-group" style="margin-top: 10px;margin-right: 30px;margin-left: 37px;width: 350px;">
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">PHONE NUMBER 2</label>
          <input type="text" class="form-control" formControlName="phoneNumber2FormControl" placeholder="Phone Number 2"
                 style="width: 350px;height: 40px;"/>
        </div>

        <!-- Phone Number 3 -->
        <div class="form-group" style="margin-top: 10px;margin-right: 30px;margin-left: 37px;width: 350px;">
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">PHONE NUMBER 3</label>
          <input type="text" class="form-control" formControlName="phoneNumber3FormControl" placeholder="Phone Number 3"
                 style="width: 350px;height: 40px;"/>
        </div>

        <!-- Email -->
        <div class="form-group" style="margin-top: 10px;margin-right: 30px;margin-left: 37px;width: 350px;">
          <label style="font-size: 11px;height: 15px;color: #7c7575;font-weight: bold;">EMAIL <span style="color:red;">*</span></label>
          <input type="text" class="form-control" formControlName="emailFormControl" placeholder="e.g. a@b.com, c@d.com"
                 style="width: 350px;height: 40px;"/>
          <div *ngIf="facilityDetailsFormGroup.get('emailFormControl').invalid && facilityDetailsFormGroup.get('emailFormControl').touched" style="color: red;font-size: 14px;">
            Enter valid email(s), comma-separated.
          </div>
        </div>
      </form>
    </div>

    <!-- Image and Button Section (Hidden on Mobile & Tablet) -->
    <div class="col-lg-6 d-none d-lg-block">
      <img src="../../assets/img/5.png" style="width: 586px;height: 342px;margin-top: 129px;margin-right: 34px;margin-bottom: 0px;" />
      <button class="btn btn-primary" type="button" (click)="onNextClicked()" [disabled]="facilityDetailsFormGroup.invalid"
              style="background-color: #14274e;height: 40px;width: 168px;float: right;margin-right: 34px;margin-top: 285px;">
        Next
      </button>
    </div>

    <!-- Mobile & Tablet Button -->
    <div class="col-12 d-lg-none text-center mt-4">
      <button class="btn btn-primary" type="button" (click)="onNextClicked()" [disabled]="facilityDetailsFormGroup.invalid"
              style="background-color: #14274e;height: 40px;width: 168px;">
        Next
      </button>
    </div>
  </div>
</div>

